// src/components/Footer.js
import React from 'react';
import { FaInstagram, FaFacebook, FaTiktok } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className=" py-10" style={{backgroundColor:"#8d0b41",
    color: "#f5f3ef"  }}>
        
            <div className="container mx-auto px-4 text-center">
                <h3 className="text-2xl font-bold mb-4">Connect With Us</h3>
                <p className="mb-8">Follow us on social media and discover local businesses with us.</p>
                
                <div className="flex justify-center space-x-6 mb-6">
                    {/* Instagram */}
                    <a href="https://www.instagram.com/chaloreview" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-300 hover:text-green-500 transition-all duration-300">
                        <FaInstagram size={30} />
                    </a>
                    {/* Facebook */}
                    <a href="https://www.Facebook.com/chaloreview" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="text-gray-300 hover:text-red-500 transition-all duration-300">
                        <FaFacebook size={30} />
                    </a>
                    {/* TikTok */}
                    <a href="https://www.tiktok.com/@chaloreview0" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="text-gray-300 hover:text-green-600 transition-all duration-300">
                        <FaTiktok size={30} />
                    </a>
                </div>

                <p className="text-sm">
                    &copy; {new Date().getFullYear()} ChaloReview. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
